import {orderContourPoints} from "./orderContourPoints";

const appendContourPoints = (acc, contourPoints) => {
    if (!contourPoints?.length) {
        return acc
    }
    const curr = [...orderContourPoints(contourPoints)]
    curr.splice(-1)
    return acc.concat(curr)
}

const appendContourFromEntity = (acc, entity) => {
    if (!entity?.contour?.points) {
        return acc
    }
    return appendContourPoints(acc, entity.contour.points)
}

export const createPointArray = (detailData) => {
    if (!detailData) {
        return []
    }

    let acc = appendContourPoints([], detailData.detailContour?.points ?? [])

    for (const notch of detailData.notches ?? []) {
        acc = appendContourFromEntity(acc, notch)
    }
    for (const roundNotch of detailData.roundNotches ?? []) {
        acc = appendContourFromEntity(acc, roundNotch)
    }
    for (const groove of detailData.grooves ?? []) {
        acc = appendContourFromEntity(acc, groove)
    }
    for (const quarter of detailData.quarters ?? []) {
        acc = appendContourFromEntity(acc, quarter)
    }

    return acc
}

export const findDetailPointById = (detailData, pointId) => {
    if (pointId == null) {
        return undefined
    }
    return createPointArray(detailData).find((el) => String(el.id) === String(pointId))
}
